export {};
//# sourceMappingURL=AiGeneratedDisclaimer.types.js.map